import styled from "styled-components";

const CustomLink = styled.div`
  width: 100%;
  height: 100%;
  .custom-link {
    color: #484848;
    text-decoration: none;
    background-color: transparent;
    width: 100%;
    height: 100%;
    display: block;
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
    &:hover {
      color: #484848;
      text-decoration: none;
      background-color: transparent;
    }
  }
`;

export default CustomLink;
